module.exports = __webpack_public_path__ + "static/media/Trailer52FT.165893ac.svg";